<form class="org-edit-form" [formGroup]="organisationForm">

  <mat-form-field appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput required placeholder="Name" formControlName="name">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Comments</mat-label>
    <textarea rows="5" matInput placeholder="Comments" formControlName="comments"></textarea>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>CRM Link</mat-label>
    <input matInput placeholder="Name" formControlName="crmLink">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Industries</mat-label>
    <mat-select multiple placeholder="Industries" [compareWith]="compareWithFn" formControlName="industries">
      <mat-option [value]="industry" *ngFor="let industry of industries$ | async">
        {{industry.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</form>